export function NewString (cad, option) {
  let new_cad = "";
  if ( option === 1 ) {
    new_cad = StringLower(cad.replace(/\s/g,"-"));
  } else if ( option === 2 ) {
    new_cad = StringUpper(cad.replace(/-/g,' '))
  } else if ( option === 3 ) {
    new_cad = cad.replace(/\s/g,"-");
  } else if ( option === 4 ) {
    new_cad = cad.replace(/-/g,' ');
  }
  return new_cad;
}

function StringLower (cad) {
  let new_cad = cad.toLowerCase();
  return new_cad;
}

function StringUpper (cad) {
  let new_cad = cad.toUpperCase();
  return new_cad;
}



// WEBPACK FOOTER //
// ./src/functions/ReplaceCharacter.js